const LOAD_DATA_MASTER_ABOUT_COUNTRIES           = 'LOAD_DATA_MASTER_ABOUT_COUNTRIES'
const LOAD_DATA_MASTER_ABOUT_COUNTRIES_SUCCESS   = 'LOAD_DATA_MASTER_ABOUT_COUNTRIES_SUCCESS'
const LOAD_DATA_MASTER_ABOUT_COUNTRIES_FAILED    = 'LOAD_DATA_MASTER_ABOUT_COUNTRIES_FAILED'
const UNMOUNT_DATA_MASTER_ABOUT_COUNTRIES        = 'UNMOUNT_DATA_MASTER_ABOUT_COUNTRIES'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterAboutCountriesReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_ABOUT_COUNTRIES:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_ABOUT_COUNTRIES_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_ABOUT_COUNTRIES_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_ABOUT_COUNTRIES:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterAboutCountriesReducer;